var ActivitySetupComponent = new JS.Class(EditorComponent, {
  initialize: function(activitySetupTabSelector) {
    this.activitySetupTab = $(activitySetupTabSelector);
  },

  getSaveData: function() {
    var setup = {
      scoring: this.activitySetupTab
        .find('input[name="activity-scoring"]:checked')
        .val(),
      submissionType: this.activitySetupTab
        .find('input[name="submission-type"]:checked')
        .val(),
      submissionGroupCategories: this.activitySetupTab
        .find('input[name="submissionGroupCategory"]:checked')
        .map(function(k, v) {
          return $(this).val();
        })
        .toArray(),
      allowAllSubmissionGroups:
        this.activitySetupTab.find(
          'input[name="allowAllSubmissionGroups"]:checked'
        ).length > 0,
      maxMarks: this.activitySetupTab.find('#activity-maxMarks').val(),
      duration: this.activitySetupTab.find('#activity-duration').val(),
      durationType: this.activitySetupTab.find('#activity-durationType').val(),
      workflow: this.activitySetupTab
        .find('input[name="activity-workflow"]:checked')
        .val(),
      submissionPageType: this.activitySetupTab
        .find('#activitySelectionInput')
        .val(),
      submissionPrivacy: this.activitySetupTab
        .find('input[name="submission-privacy"]:checked')
        .val(),
      templateText: this.activitySetupTab.find('#template-text').val(),
      canBeViewedEarly: this.activitySetupTab
        .find('#activity-canBeViewedEarly')
        .is(':checked'),
      allowEarlySubmissions: this.activitySetupTab
        .find('#activity-allowEarlySubmissions')
        .is(':checked'),
      allowLateSubmissions: this.activitySetupTab
        .find('#activity-allowLateSubmissions')
        .is(':checked'),
      appId: this.activitySetupTab.find('#appId').val(),
      activityCommenting: this.activitySetupTab
        .find('input[name="activity-commenting"]:checked')
        .val(),
    };

    return {
      ActivitySetup: setup,
    };
  },

  _handleSetActivityConfig: function(data) {
    this.editor.savePage();
  },
});
